module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"label":"Kommentar (optional)"},"en":{"label":"Comment (optional)"}}')
  delete Component.options._Ctor
}
